import React, { Component } from "react";
import { UserAgentApplication , Logger, LogLevel} from "msal";
import { Providers, MsalProvider, TeamsProvider} from "@microsoft/mgt";
import config from "../../auth/Config";

import { ErrorMessage } from "../account/ErrorMessage";
import  { Welcome }  from "../account/Welcome";

import { getUserDetails } from "../../auth/user";
import log from 'loglevel';

let accessToken = null;

export default class AppAuthContainer extends Component {
                 constructor(props) {
                   super(props);

                   function loggerCallback(logLevel, message, containsPii) {
                      log.info(`loggerCallback(logLevel, message, containsPii)`);
                      log.error(`loggerCallback @ userAgentApplication: ${message}`);
                    // const str = "cache";
                    // const tokenIsCached = JSON.stringify(message).includes(str);
                    // log.error(`loggerCallback @ userAgentApplication : ${tokenIsCached}`);
                    // // if (tokenIsCached) {
                    // //   this.getUserProfile();
                    // // }
                    
                   }

                   let provider;

                   this.userAgentApplication = new UserAgentApplication({
                     auth: {
                       clientId: config.appId,
                     },
                     cache: {
                       //   cacheLocation: "localStorage",
                       storeAuthStateInCookie: false,
                     },
                     system: {
                       logger: new Logger(loggerCallback, {
                         level: LogLevel.Error,
                         piiLoggingEnabled: false,
                         correlationId: "1234",
                       }),
                     },
                     redirectUri: window.location.origin,
                       //"https://reader-365-teams-notelettes.netlify.app",
                     postLogoutRedirectUri: window.location.origin
                       //"https://reader-365-teams-notelettes.netlify.app",
                   });

                   var user = this.userAgentApplication.getAccount();
                   this.state = {
                     isAuthenticated: user !== null,
                     user: {},
                     error: null,
                   };

                   if (user) {
                     this.getUserProfile();
                   }
                 }

                 render() {
                   log.info(`render() @ appAuthContainer`);
                   let error = null;
                   if (this.state.error) {
                     error = (
                       <ErrorMessage
                         message={this.state.error.message}
                         debug={this.state.error.debug}
                       />
                     );
                   }

                   return (
                     <div>
                       {error}
                       <Welcome
                         isAuthenticated={this.state.isAuthenticated}
                         user={this.state.user}
                         handleLogin={this.login.bind(this)}
                         handleLogout={this.logout.bind(this)}
                         accessToken={this.state.accessToken}
                       />
                     </div>
                   );
                 }

                 setErrorMessage(message, debug) {
                   log.info(
                     `setErrorMessage(message, debug) @ appAuthContainer`
                   );
                   this.setState({
                     error: { message: message, debug: debug },
                   });
                 }

                 async login() {
                   log.info(`login() @ appAuthContainer`);
                   try {

                            log.debug(`user is not loggedin call loginpoppup @ appAuthContainer`);
                            await this.userAgentApplication.loginPopup({
                              scopes: config.scopes,
                              prompt: "select_account",
                            });
                     
                          await this.getUserProfile();
                   } catch (err) {
                     log.error(`login() @ appAuthContainer ${err}`);
                       this.setState({
                         isAuthenticated: false,
                         user: {},
                         error: { message: JSON.stringify(err) },
                       });

                   }
                 }

                //  async login() {
                //    log.info(`login() @ appAuthContainer`);
                //    try {
                //      if (TeamsProvider.isAvailable) {
                //        this.provider = new TeamsProvider({
                //          clientId: config.appId,
                //          scopes: config.scopes,
                //          authPopupUrl: `/teamsauth`,
                //        });
                //      } else {
                //        this.provider = new MsalProvider({
                //          clientId: config.appId,
                //          scopes: config.scopes,
                //          redirectUri:
                //            "https://reader-365-teams-notelettes.netlify.app",
                //          loginHint: `admin@gilstavdev.onmicrosoft.com`,
                //          extraQueryParameters: {domain_hint: 'organizations'}
                //        });
                //      }
                //      await this.getUserProfile();
                //    } catch (err) {
                //      this.setState({
                //        isAuthenticated: false,
                //        user: {},
                //        error: { message: JSON.stringify(err) },
                //      });
                //    }
                //  }

                 logout() {
                   log.info(`logout() @ appAuthContainer`);
                   try {
                     //   this.userAgentApplication.logout();
                     const config = {
                       auth: {
                         clientId: config.appId,
                         redirectUri: //window.location.origin,
                          "https://reader-365-teams-notelettes.netlify.app", //defaults to application start page

                         postLogoutRedirectUri: //window.location.origin
                         "https://reader-365-teams-notelettes.netlify.app",

                       },
                     };

                     const userAgentApplication = new UserAgentApplication(
                       config
                     );
                     userAgentApplication
                       .logout()
                       .then((response) => {
                         // handle response
                       })
                       .catch((err) => {
                         log.error(
                           `Catch error @ logout ${JSON.stringify(err)}`
                         );
                       });
                   } catch (err) {
                     log.error(`Catch error @ logout ${JSON.stringify(err)}`);
                   } finally {
                     sessionStorage.clear();
                     this.setState({
                       isAuthenticated: null,
                       user: {},
                       error: null,
                       accessToken: null,
                     });
                   }
                 }

                 async getUserProfile() {
                   log.info(`getUserProfile() @ appAuthContainer`);
                   try {
                     // Get the access token silently
                     // If the cache contains a non-expired token, this function
                     // will just return the cached token. Otherwise, it will
                     // make a request to the Azure OAuth endpoint to get a token
                     accessToken = await this.userAgentApplication.acquireTokenSilent(
                       {
                         scopes: config.scopes,
                       }
                     );


                     log.debug(
                       "accestoken @ getUserProfile: " +
                         JSON.stringify(accessToken)
                     );

                     if (accessToken) {
                       this.setState({
                         accessToken: accessToken,
                       });
                       // Get the user's profile from Graph
                       var user = await getUserDetails(accessToken);

                       this.setState({
                         isAuthenticated: true,
                         user: {
                           displayName: user.displayName,
                           email: user.mail || user.userPrincipalName,
                         },
                         error: null,
                       });
                     }
                   } catch (err) {
                     var error = {};
                     if (typeof err === "string") {
                       var errParts = err.split("|");
                       error =
                         errParts.length > 1
                           ? { message: errParts[1], debug: errParts[0] }
                           : { message: err };
                     } else {
                       error = {
                         message: err.message,
                         debug: JSON.stringify(err),
                       };
                     }

                     this.setState({
                       isAuthenticated: false,
                       user: {},
                       error: error,
                     });
                   }
                 }
               }




//                //check for Navigation Timing API support
// if (window.performance) {
//   console.info("window.performance works fine on this browser");
// }
//   if (performance.navigation.type == 1) {
//     console.info( "This page is reloaded" );
//   } else {
//     console.info( "This page is not reloaded");
//   }